module.exports = __webpack_public_path__ + "4397c5f2de569b449f0206f9ff416943.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_bg.jpg
// module id = 576
// module chunks = 0